// Variant Thumbnails Functionality
function changeMainImage(newImageUrl, thumbnailElement) {
  // Find the main product image in the same card
  const card = thumbnailElement.closest('.card-wrapper');
  const mainImage = card.querySelector('.card__media .media img');
  
  if (mainImage) {
    // Change the main image source
    mainImage.src = newImageUrl;
    
    // Update srcset for responsive images
    const baseUrl = newImageUrl.split('?')[0];
    const newSrcset = [
      `${baseUrl}?width=165 165w`,
      `${baseUrl}?width=360 360w`,
      `${baseUrl}?width=533 533w`,
      `${baseUrl}?width=720 720w`,
      `${baseUrl}?width=940 940w`,
      `${baseUrl}?width=1066 1066w`
    ].join(', ');
    
    mainImage.srcset = newSrcset;
    
    // Update active thumbnail indicators
    updateActiveThumbnail(thumbnailElement);
  }
}

function updateActiveThumbnail(activeThumbnail) {
  // Find all thumbnails in the same card
  const card = activeThumbnail.closest('.card-wrapper');
  const allThumbnails = card.querySelectorAll('.variant-thumbnails img');
  
  // Reset all thumbnails to inactive state (dotted border)
  allThumbnails.forEach(thumb => {
    thumb.style.borderStyle = 'dotted';
  });
  
  // Set active thumbnail (solid border)
  const activeImg = activeThumbnail.querySelector('img') || activeThumbnail;
  activeImg.style.borderStyle = 'solid';
}

// Set initial active thumbnail on page load
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.card-wrapper');
  
  cards.forEach(card => {
    const mainImage = card.querySelector('.card__media .media img');
    const thumbnails = card.querySelectorAll('.variant-thumbnails img');
    
    if (mainImage && thumbnails.length > 0) {
      const mainImageUrl = mainImage.src;
      let foundMatch = false;
      
      // Find matching thumbnail and mark as active
      thumbnails.forEach(thumbnail => {
        const thumbnailUrl = thumbnail.src;
        const thumbnailBaseUrl = thumbnailUrl.split('?')[0];
        const mainImageBaseUrl = mainImageUrl.split('?')[0];
        
        if (thumbnailBaseUrl === mainImageBaseUrl && !foundMatch) {
          thumbnail.style.borderStyle = 'solid';
          foundMatch = true;
        } else {
          thumbnail.style.borderStyle = 'dotted';
        }
      });
      
      // If no match found, mark first thumbnail as active
      if (!foundMatch && thumbnails.length > 0) {
        thumbnails[0].style.borderStyle = 'solid';
      }
    }
  });
}); 